import { getReferralsByCrmId } from 'packages/tackle-api/src/co-sell-msft';
import { useQuery } from '@tanstack/react-query';

export default function useMsftReferralsForCrmId({
  crmId,
  enabled = false,
}: {
  crmId: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['msft-referrals-by-crmId', crmId],
    queryFn: () => getReferralsByCrmId({ crmId }),
    enabled: !!enabled && !!crmId,
    retry: 2,
  });
}
